/*
 * Copyright (c) 2023 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    pendingCancelation: {
        defaultMessage: "Something is wrong with your code, please retry or get a new code",
        id: "application.login.error.wrongCode",
    },
    phoneNumberPlaceholder: {
        defaultMessage: "Phone number",
        id: "application.login.phone.placeholder",
    },
    problemReceivingCode: {
        defaultMessage: "Problems receiving code",
        id: "application.login.phone.problemReceivingCode",
    },
    phoneNumberMaxMinLengthValidationError: {
        defaultMessage: "A phone number must contain between 7 and 20 digits",
        id: "application.login.phone.minMaxLengthError",
    },
});
